import { createMuiTheme } from '@material-ui/core/styles';

export const AppTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#00A591',
    },
    typography: {
      fontFamily: ['Poppins'],
    },
  },
});
